export const QUALIFICATION_MODEL = "qualification";

const qualificationModel = {
  qualificationSubject: "",
  qualificationType: "",
  qualificationInstitution: "",
  qualificationGrade: "",
  dateStarted: "",
  dateCompleted: "",
  user: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default qualificationModel;
